export enum BuilderState {
  INITIAL,
  LOADING,
  ERROR,
  COMPLETE
}
